import baseTheme from '../base'

const MuiLoadingButton = {
  defaultProps: {
    color: 'inherit',
    variant: 'contained',
  },
  styleOverrides: {
    root: {
      ...baseTheme.typography.body2,
    },
  },
}

export default MuiLoadingButton
